const PENDING_AI_SUBSCRIPTION_INTENT_KEY = "lexmom-pending-ai-subscription";

const canUseStorage = () => typeof window !== "undefined" && window.localStorage;

const normalizeIntent = (value) => {
  if (!value || typeof value !== "object") {
    return null;
  }

  const botCode =
    typeof value.botCode === "string" ? value.botCode.trim() : "";
  const aiName = typeof value.aiName === "string" ? value.aiName.trim() : "";
  const sourcePath =
    typeof value.sourcePath === "string" ? value.sourcePath.trim() : "";

  if (!botCode) {
    return null;
  }

  return {
    botCode,
    aiName: aiName || botCode,
    sourcePath: sourcePath || "/dashboard/ai",
    createdAt:
      typeof value.createdAt === "string" ? value.createdAt : new Date().toISOString(),
  };
};

export const getPendingAISubscriptionIntent = () => {
  if (!canUseStorage()) {
    return null;
  }

  const rawValue = window.localStorage.getItem(PENDING_AI_SUBSCRIPTION_INTENT_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawValue);
    const normalized = normalizeIntent(parsed);

    if (!normalized) {
      window.localStorage.removeItem(PENDING_AI_SUBSCRIPTION_INTENT_KEY);
    }

    return normalized;
  } catch (error) {
    window.localStorage.removeItem(PENDING_AI_SUBSCRIPTION_INTENT_KEY);
    return null;
  }
};

export const persistPendingAISubscriptionIntent = (value) => {
  if (!canUseStorage()) {
    return null;
  }

  const normalized = normalizeIntent(value);

  if (!normalized) {
    window.localStorage.removeItem(PENDING_AI_SUBSCRIPTION_INTENT_KEY);
    return null;
  }

  window.localStorage.setItem(
    PENDING_AI_SUBSCRIPTION_INTENT_KEY,
    JSON.stringify(normalized),
  );

  return normalized;
};

export const clearPendingAISubscriptionIntent = () => {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.removeItem(PENDING_AI_SUBSCRIPTION_INTENT_KEY);
};
